import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import RequestPage from '../pages/RequestPage';

/** I clienti loggati compilano la richiesta dentro l'area riservata, non sulla landing. */
const RequestRouteSwitch = () => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Caricamento...</div>
      </div>
    );
  }
  if (isAuthenticated && user?.role === 'user') {
    return <Navigate to="/dashboard/nuova-richiesta" replace />;
  }
  return <RequestPage />;
};

export default RequestRouteSwitch;
